import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "./Sidebar";
import SplitPane from "react-split-pane";
import pixaLogo from "../Img/pixaLogo.png";
import AdminHeader from "./AdminHeader";
import BlogCategoryManagement from "./BlogManagement/CategoryManagement/BlogCategoryManagement";
import BlogSubCategoryManagement from "./BlogManagement/SubCategoryManagement/BlogSubCategoryManagement";
import DesignationManagement from "./DesignationManagement/DesignationManagement";
import UserManagement from "./UserManagement/UserManagement";
import OtherImageLibraryMetaManagement from "./OtherImageLibraryManagement/OtherImageLibraryManagement";
import Application from "./Application";
import ManageAccount from "./Profile/ManageAccount";
import BlogManagement from "./BlogManagement/BlogManagemnt/BlogManagement";

const AppDashboard = ({ getCurrectLoginUser, currentUserData }) => {
  const [activeItem, setActiveItem] = useState("");
  return (
    <>
      <Container fluid>
        <Row>
          <Col md={12} className="p-0">
            <SplitPane
              split="vertical"
              minSize={"20%"}
              className="position-relative"
              style={{ height: "100vh" }}
            >
              <div className="bg-light">
                <div className="p-2">
                  <img src={pixaLogo} alt="" style={{ height: 38, objectFit: "contain" }} />
                </div>
                <Sidebar
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
              </div>
              <div>
                <AdminHeader
                  getCurrectLoginUser={getCurrectLoginUser}
                  currentUserData={currentUserData}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
                {activeItem === "manageAccount" &&
                  <ManageAccount
                    currentUserData={currentUserData}
                    getCurrectLoginUser={getCurrectLoginUser}
                  />
                }
                {activeItem === "blogCategory" &&
                  <BlogCategoryManagement />
                }
                {activeItem === "blogSubCategory" &&
                  <BlogSubCategoryManagement />
                }
                {activeItem === "blogPost" &&
                  <BlogManagement />
                }
                {activeItem === "designation" &&
                  <DesignationManagement />
                }
                {activeItem === "users" &&
                  <UserManagement />
                }
                {activeItem === "otherLibrary" &&
                  <OtherImageLibraryMetaManagement />
                }
                {activeItem === "applications" &&
                  <Application />
                }
              </div>
            </SplitPane>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AppDashboard;
